
<nb-card>
  <nb-card-header>

    <div class="MealEditingLocation">
      <span >
        <span>{{FitnessBlockOrderName}}</span>
        <span style="font-size:12pt;" *ngIf="FitnessBlock.blockType == BlockType.Circuit">
          <span> - </span>
          <span>Circuit, repeat {{FitnessBlock.repetitionCount}}X </span>
        </span>
      </span>
    </div>
   
  </nb-card-header>

  <nb-card-body>

    <div class="row row_mobile">
      <div class="col-lg-12">
        <div class="row">
          <!--<mobile-app-meal-items-presentation #MealItems [PlanMeal]="PlanMeal" style="width:100%"></mobile-app-meal-items-presentation>--->
          <!--<div class="col-md-4" style="padding-bottom:20px; max-width:200px; padding-left:5px; padding-right:5px" *ngFor="let item of PlanMeal.items; let i = index;">-->

          <div class="mobile_fitness_item" *ngFor="let item of FitnessBlockItems(); let i = index; let isLast = last;">
            <div class="container" style="padding-left:5px;">
              <app-fitness-item-presentation [PatientID]="PatientID" [PatientName]="PatientName" [IsPreferredUnitImperial]="IsPreferredUnitImperial" [FitnessItem]="item" [IsPatientView]="true"
                [IsLastItem]="isLast"
                [BlockOrder]="FitnessBlock.order" [fitnessBlock]="FitnessBlock" [BlockType]="FitnessBlock.blockType" [CircuitRest]="FitnessBlock.circuitRest"></app-fitness-item-presentation>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-12 mobile_meal_graph">
        <div style="float:right; margin-top:10px;">
          <app-fitness-summary #FitnessSummaryView
                               class="Metrics {{PlanView ? 'plan-view' :''}}"
                               [Exercises]="BlockExercises"
                               [Reps]="BlockReps"
                               [Minutes]="BlockMinutes">
          </app-fitness-summary>
        </div>
      </div>
    </div>

  </nb-card-body>
</nb-card>



